module.exports = __webpack_public_path__ + "static/media/image1.2420b0cb.jpeg";